import { render, staticRenderFns } from "./DistributeMessageForm.vue?vue&type=template&id=59d95541"
import script from "./DistributeMessageForm.vue?vue&type=script&lang=js"
export * from "./DistributeMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports